import React from "react";
import Signup from "../../components/Auth/Signup";
import "./styles.scss";

const Registration = (props: any) => {
  return <Signup />;
};

export default Registration;